"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/APIKeys/components/APIKeyExpiryModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _noticeBar = require('web/services/context/noticeBar');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _helpers = require('../helpers');








// Picks a new expiry, counted from now. Choosing "Never" asks once more
// before anything is sent.
const APIKeyExpiryModal = ({ isOpen, onClose, apiKey, onProceed }) => {
  const [expires, setExpires] = _react.useState(_helpers.DEFAULT_EXPIRY)
  const [isConfirmingNever, setIsConfirmingNever] = _react.useState.call(void 0, false)
  const [isLoading, setIsLoading] = _react.useState.call(void 0, false)
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )

  const close = () => {
    setExpires(_helpers.DEFAULT_EXPIRY)
    setIsConfirmingNever(false)
    onClose()
  }

  const send = () => {
    setIsLoading(true)
    onProceed(expires)
      .then(() => showSuccessBar(`Updated the expiry of "${apiKey.Name}".`))
      .then(close)
      .catch(() => showWarningBar('Failed to change the expiry of the API key.'))
      .finally(() => setIsLoading(false))
  }

  const onSave = () => expires === 'never' ? setIsConfirmingNever(true) : send()

  if (isConfirmingNever) {
    return (
      _react2.default.createElement(_Modal2.default, { isOpen: isOpen, onClose: close, title: `Never expire "${apiKey.Name}"?`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
        , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}, "Keys that never expire stay valid until someone revokes them. If this key leaks, anyone can use it until then."


        )
        , _react2.default.createElement(_Modal.ModalControls, {
          primaryBtnTheme: "danger",
          primaryBtnLabel: "Never expire" ,
          isPrimaryLoading: isLoading,
          onPrimaryBtnClick: send,
          secondaryBtnLabel: "Cancel",
          onSecondaryBtnClick: close, __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
        )
      )
    )
  }

  return (
    _react2.default.createElement(_Modal2.default, { isOpen: isOpen, onClose: close, title: `Change expiry of "${apiKey.Name}"`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
      , _react2.default.createElement('label', { className: "settings--org-api-keys--expiry-field", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}, "Expires in"

        , _react2.default.createElement(_Form.SimpleSelect, { value: expires, onChange: setExpires, options: _helpers.EXPIRY_OPTIONS, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}} )
      )
      , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}, "The new expiry counts from now."     )
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: "Save",
        isPrimaryLoading: isLoading,
        onPrimaryBtnClick: onSave,
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: close, __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
      )
    )
  )
}

exports. default = APIKeyExpiryModal
